import { render } from "./App.vue?vue&type=template&id=5a52e241"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=5a52e241&lang=css"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.21_webpack@5.90.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__